import { render, staticRenderFns } from "./LessonBuilderItem.vue?vue&type=template&id=0b24468a&scoped=true&"
import script from "./LessonBuilderItem.vue?vue&type=script&lang=js&"
export * from "./LessonBuilderItem.vue?vue&type=script&lang=js&"
import style0 from "./LessonBuilderItem.vue?vue&type=style&index=0&id=0b24468a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b24468a",
  null
  
)

component.options.__file = "LessonBuilderItem.vue"
export default component.exports